/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */

import {ApiV0} from "../api.v0";
import {Observable} from 'rxjs';
import {ProductDetailsRes, ProductReleaseReq, VersionInfoRes,} from '../../../contracts/v0/cp';
import {RestApiService} from '../../rest-api.service';

export class ApiV0Version {
    segment = '/version';

    constructor(v0: ApiV0, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }


    release(productId: string, release: ProductReleaseReq): Observable<ProductDetailsRes> {
        release.productId = productId;
        return this.rest.post<ProductReleaseReq, ProductDetailsRes>(
            `${this.segment}/Release`,
            ProductDetailsRes,
            release
        );
    }

    getVersion() {
        return this.rest.get<VersionInfoRes>(
            `${this.segment}/`,
            VersionInfoRes,
        );

    }
}
